import { createSelector } from "reselect";
import _ from "lodash";

const selectedFiltersSelector = state => state.reportFilters;
const reportsSelector = state => state.reports;
//const errorsSelector = state => state.logSourceErrors;

export const getFilters = createSelector(
  selectedFiltersSelector,
  reportsSelector,
  (selectedFilters, reports) => {
    const reportGroups = _.groupBy(reports, report => report.title);
    const filters = Object.keys(reportGroups).map(key => {
      const isSelected = selectedFilters.filter(sf => sf === key).length > 0;
      return { key, isSelected };
    });

    return _.sortBy(filters, filter => filter.key);
  }
);

export const getVisibleReportGroups = createSelector(
  selectedFiltersSelector,
  reportsSelector,
  (selectedFilters, reports) => {
    const hasNoSelectedFilters = selectedFilters.length === 0;
    return reports.filter(
      report =>
        selectedFilters.some(sf => sf === report.title) || hasNoSelectedFilters
    );
  }
);



// WEBPACK FOOTER //
// ./src/reports/reportSelectors.js